




































import { Component, Prop } from 'vue-property-decorator'

import { ButtonView, SocketNames } from "../../../../../../components";
import ConstantValue from '../../../../Branching/ConditionsNode/logic/PropertyConditionValues/ConstantValue'
import PropertyValue from '../../../../Branching/ConditionsNode/logic/PropertyConditionValues/PropertyValue';
import { SampleNodeMixin } from '../../../../index'
import { HttpRequestNode } from '../../logic/HttpRequestNode'

@Component({
  components: {
    ButtonView
  },
  data() {
    return {
      PropertyValue,
      ConstantValue,
      SocketNames
    }
  }
})
export default class HttpRequestSampleNode extends SampleNodeMixin {
  @Prop() node!: HttpRequestNode

  get fields() {
    return [
      { title: this.i18n.t('field_method_title').toString(), value: this.node.data.method },
      { title: "URL", value: this.node.data.url },
    ]
  }
}
